import { render, staticRenderFns } from "./VoyagePlan.vue?vue&type=template&id=0b0194f0&scoped=true&"
import script from "./VoyagePlan.vue?vue&type=script&lang=js&"
export * from "./VoyagePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0194f0",
  null
  
)

export default component.exports